module.exports = __webpack_public_path__ + "static/media/01-AXONOMETRICKY POHLAD_page-0001.8e918ad2.jpg";